import React, { useState, useEffect, useCallback } from 'react';
import TaxGrid from './TaxGrid';
import TaxModal from './TaxModal';
import DeleteConfirmModal from '../../common/DeleteConfirmModal';
import ViewToolbar from '../../common/ViewToolbar';
import { useModal } from '../../../hooks/useModal';
import * as taxService from '../../../services/taxService';

export default function TaxesView() {
  const [taxes, setTaxes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [gridApi, setGridApi] = useState(null);

  const editModal = useModal();
  const deleteModal = useModal();

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      setTaxes(await taxService.fetchTaxes());
    } catch (err) {
      console.error('Error fetching taxes:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleSave = async (formData) => {
    try {
      if (editModal.record) {
        await taxService.updateTax(editModal.record.tax_id, formData);
      } else {
        await taxService.createTax(formData);
      }
      editModal.close();
      fetchData();
    } catch (err) {
      alert('Failed to save: ' + err.message);
    }
  };

  const handleDelete = async () => {
    try {
      await taxService.deleteTax(deleteModal.record.tax_id);
      deleteModal.close();
      fetchData();
    } catch (err) {
      alert('Failed to delete: ' + err.message);
    }
  };

  if (loading) return <div className="flex justify-center mt-10">Loading...</div>;

  return (
    <>
      <ViewToolbar
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        onAddNew={() => editModal.open(null)}
        onExportCsv={() => gridApi?.exportToCsv()}
        placeholder="Search taxes..."
      />
      <div className="flex-1 min-h-0">
        <TaxGrid
          rowData={taxes}
          onEdit={(r) => editModal.open(r)}
          onDelete={(r) => deleteModal.open(r)}
          onGridReady={setGridApi}
        />
      </div>
      <TaxModal
        isOpen={editModal.isOpen}
        onClose={editModal.close}
        onSubmit={handleSave}
        initialData={editModal.record}
        title={editModal.record ? 'Edit Tax Code' : 'Add New Tax Code'}
      />
      <DeleteConfirmModal
        isOpen={deleteModal.isOpen}
        onClose={deleteModal.close}
        onConfirm={handleDelete}
        recordName={deleteModal.record?.tax_id || 'this record'}
      />
    </>
  );
}
